import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Mode } from '../../constants/enums';

const useStyles = makeStyles((theme: Theme) => ({
  contactName: {
    fontWeight: 600,
    textTransform: 'capitalize',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    '& hr': {
      width: '1px',
      height: '15px',
      backgroundColor: '#919392',
    },
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    fontWeight: 800,
    fontSize: '20px',
    '& img': { width: '40px' },
    color: theme.palette.secondary.contrastText,
  },
  appBar: {
    position: 'relative',
    background:
      theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.primary.main,
    display: 'flex',
    padding: '20px',
    boxSizing: 'border-box',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderRadius: '8px 8px 0 0',
    '& svg': {
      cursor: 'pointer',
      width: '20px !important',
      height: '20px !important',
      '& path': {
        stroke:
          theme.palette.mode === Mode.Dark
            ? theme.palette.common.white
            : theme.palette.secondary.contrastText,
        fill:
          theme.palette.mode === Mode.Dark
            ? theme.palette.common.white
            : theme.palette.secondary.contrastText,
      },
    },
    '& .MuiTypography-root': {
      color:
        theme.palette.mode === Mode.Dark
          ? theme.palette.common.white
          : theme.palette.secondary.contrastText,
    },
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: 'calc(100% - 300px)',
    overflow: 'hidden',
    boxSizing: 'border-box',
    padding: '12px',
    backgroundColor: '#b0afb0',
  },
  notificationItem: {
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    cursor: 'pointer',
    '& svg': {
      minWidth: '25px',
      minHeight: '25px',
      width: '25px',
      height: '25px',
      '& path': { fill: '#646464' },
    },
  },
  notificationsList: {
    display: 'flex',
    gap: '5px',
    padding: '5px 20px',
    boxSizing: 'border-box',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  notificationMenuText: {
    width: '100%',
    height: 'inherit',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'inherit',
    maxHeight: 'inherit',
  },
  notificationMenu: {
    '& ul': { padding: '0' },
  },
  technicianDataField: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  loader: {
    color: 'white !important',
    width: 'unset !important',
    height: 'unset !important',
  },
  dialogButton: {
    margin: '15px 0px',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  margin5: {
    margin: '5px',
  },
  mainContent: {
    height: 'calc(100% - 80px)',
    overflow: 'auto',
    borderRadius: '0 0 8px 8px',
    backgroundColor: theme.palette.background.paper,
  },
  noLayoutWrapper: {
    width: '100%',
    height: '100%',
    background: theme.palette.background.default,
  },
  techVerificationButton: {
    fontSize: 'small',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'row',
    gap: '2px',
    alignItems: 'center',
    cursor: 'pointer',
    border: '1px solid var(--color-primary)',
    padding: '5px 10px',
    boxSizing: 'border-box',
    color: 'var(--color-primary)',
    '& svg': {
      width: '25px',
      height: '25px',
      fill: 'var(--color-primary)',
    },
  },
  processingCircle: {
    color: 'var(--color-primary)',
    width: '25px !important',
    height: '25px !important',
    '& svg': { width: '25px', height: '25px' },
  },
  processingCircleTeams: {
    '& circle': {
      color:
        theme.palette.mode === 'dark'
          ? theme.palette.common.white
          : theme.palette.secondary.contrastText,
    },
    width: '25px !important',
    height: '25px !important',
    '& svg': { width: '25px', height: '25px' },
  },
  techName: {
    margin: '10px 0',
  },
  layout: {
    height: '100%',
    width: '100%',
    display: 'flex',
    background: theme.palette.mode === Mode.Dark ? theme.palette.background.default : 'white',
  },
  sidebar: {
    width: '300px',
    minWidth: '300px',
    height: '100%',
    backgroundColor:
      theme.palette.mode === Mode.Dark ? theme.palette.common.black : theme.palette.primary.main,
    color: theme.palette.text.primary,
  },
  sidebarLogo: {
    padding: '10px',
    width: '300px',
    display: 'flex',
    justifyContent: 'center',
    boxSizing: 'border-box',
    '& img': {
      maxWidth: '100%',
      maxHeight: '60px',
      objectFit: 'contain',
    },
    '& svg': {
      cursor: 'pointer',
      width: '24px',
      height: '24px',
      '& path': {
        fill: '#919392',
      },
      '&:hover': {
        '& path': { fill: '#fff' },
      },
    },
  },
  sidebarItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    boxSizing: 'border-box',
    padding: '0px 15px',
    marginTop: '10px',
  },
  sidebarItem: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '10px 15px',
    background: 'transparent',
    borderRadius: '5px',
    boxSizing: 'border-box',
    fontWeight: '700',
    cursor: 'pointer',
    color: theme.palette.mode === Mode.Dark ? '#fff' : theme.palette.secondary.contrastText,
    '& svg': {
      width: '25px',
      height: '25px',
      '& path': {
        fill: theme.palette.mode === Mode.Dark ? '#fff' : theme.palette.secondary.contrastText,
      },
    },
    '&:hover': {
      background: 'rgba(255,255,255,0.25)',
    },
  },
  sidebarItemActive: {
    '&:after': {
      width: '100%',
      height: '100%',
      position: 'absolute',
      content: '""',
      left: 0,
      top: 0,
      background: theme.palette.mode === Mode.Dark ? '#fff' : theme.palette.secondary.contrastText,
      opacity: 0.15,
    },
  },
  caption: {
    color: 'white',
  },
  code: {
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 600,
  },
  button: {
    color:
      theme.palette.mode === Mode.Dark
        ? `${theme.palette.common.white} !important`
        : `${theme.palette.secondary.contrastText} !important`,
  },
  captionContainer: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  verifyButton: {
    '&.MuiButtonBase-root': {
      padding: '20px',
      borderRadius: '12px',
      fontSize: '18px',

      '& .MuiButton-startIcon': {
        position: 'absolute',
        left: '20px',
        background: '#eff2fb',
        borderRadius: '50%',
        height: '44px',
        width: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 0,
      },
      '& .MuiButton-endIcon': {
        position: 'absolute',
        right: '20px',
      },

      '& svg': {
        stroke: theme.palette.mode === Mode.Dark ? '#000' : undefined,
        '& path': {
          fill: theme.palette.mode === Mode.Dark ? '#fff' : undefined,
        },
      },
    },
  },
  shadowWrapper: {
    height: '100%',
    borderRadius: '8px 8px 0 0',
    boxShadow: `
      -6px 0 8px -4px #F0F4F3,
       6px 0 8px -4px #F0F4F3
    `,
  }
}));

export default useStyles;
